import type { Key } from 'react';

const NONE = 0;

interface UseFileSelectionParams {
	pageFileIds: string[];
	selectedFileIds: string[];
	onSelectFiles: (fileIds: string[]) => void;
}

export type UseFileSelectionResult = {
	isAllSelected: boolean;
	handleToggleAllFiles: () => void;
	handleSelectionChange: (keys: Key[]) => void;
};

export function useFileSelection({
	pageFileIds,
	selectedFileIds,
	onSelectFiles
}: UseFileSelectionParams): UseFileSelectionResult {
	const isAllSelected = pageFileIds.length > NONE && pageFileIds.every((id) => selectedFileIds.includes(id));

	function handleToggleAllFiles(): void {
		if (isAllSelected) {
			const remainingFileIds = selectedFileIds.filter((id) => !pageFileIds.includes(id));

			onSelectFiles(remainingFileIds);
			return;
		}

		const merged = new Set([...selectedFileIds, ...pageFileIds]);

		const mergedFileIds = Array.from(merged);

		onSelectFiles(mergedFileIds);
	}

	function handleSelectionChange(keys: Key[]): void {
		const fileIds = keys.map(String);

		onSelectFiles(fileIds);
	}

	return { isAllSelected, handleToggleAllFiles, handleSelectionChange };
}
